// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26_PA","footer":"styles_footer__1MT1b"};